import { Table } from "antd";
import EmptySection from "../Layout/EmptySection";
import { perPageOptions } from "../../constant";

const DataTable = ({
  columns,
  data,
  handleChange,
  handleRow,
  rowSelection,
  className = "",
  scroll,
  Showpagination = true,
  pagination,
  disableHover = false,
  noDataText = "Data",
  customEmptySection = null,
  ...rest
}) => {
  const onRowClick = (record, rowIndex) => {
    return {
      onClick: () => {
        if (handleRow) {
          handleRow(record, rowIndex);
        }

        // If rowSelection exists, also trigger selection
        if (rowSelection && typeof rowSelection.onChange === "function") {
          // Determine new selected keys array
          let newSelectedKeys = [];

          if (rowSelection.type === "radio") {
            newSelectedKeys = [record.key];
          } else if (rowSelection.type === "checkbox") {
            const currentKeys = rowSelection.selectedRowKeys || [];
            if (currentKeys.includes(record.key)) {
              newSelectedKeys = currentKeys.filter((k) => k !== record.key);
            } else {
              newSelectedKeys = [...currentKeys, record.key];
            }
          }

          rowSelection.onChange(
            newSelectedKeys,
            data.filter((d) => newSelectedKeys.includes(d.key))
          );
        }
      },
    };
  };

  return (
    <Table
      columns={columns}
      dataSource={data}
      onRow={onRowClick}
      locale={{
        emptyText: customEmptySection || <EmptySection noDataText={noDataText} />,
      }}
      tableLayout="auto"
      className={`light-scroll px-4 [&_.ant-table-cell]:max-w-[200px] [&_.ant-table-cell]:truncate ${className} ${
        !disableHover ? "custom-hover-table" : ""
      }`}
      rowClassName={(record) =>
        rowSelection?.selectedRowKeys?.includes(record.key)
          ? "ant-table-row-selected"
          : "custom-row"
      }
      onChange={handleChange}
      rowSelection={rowSelection || undefined} // optional
      bordered={false}
      pagination={
        Showpagination
          ? {
              ...pagination,
              pageSizeOptions: perPageOptions,
              defaultPageSize: 10,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
            }
          : false
      }
      scroll={{ x: "max-content", y:scroll?.y }}
      {...rest}
    />
  );
};

export default DataTable;
